const SyncState = {
    CHECK_CONNECTIVITY: 'CHECK_CONNECTIVITY',

    LOGIN_FB: 'LOGIN_FB',

    LOGIN_WDM: 'LOGIN_WDM',

    IMPORT_FRIENDS: 'IMPORT_FRIENDS',

    FETCH_FRIENDS: 'FETCH_FRIENDS',

    SAVE_FRIENDS: 'SAVE_FRIENDS',

    CALCULATE_FRIENDS: 'CALCULATE_FRIENDS',

    SAVE_RESULTS: 'SAVE_RESULTS',

    SEND_RESULTS: 'SEND_RESULTS',

    // CHECK_DEACTIVATE: 'CHECK_DEACTIVATE',

    // FINISHED: 'FINISHED',

    // SAVE_STATUS: 'SAVE_STATUS',
};

module.exports = SyncState;
